/**
 * The patient portal is the only patient-facing surface in this app; every
 * other route is used by clinic staff. See useAnalytics.ts for what that gates.
 */
export const PATIENT_PORTAL_PATH_PREFIX = "/patient-portal";

/** True for the portal root and anything nested under it. */
export function isPatientPortalPath(pathname: string): boolean {
  return (
    pathname === PATIENT_PORTAL_PATH_PREFIX ||
    pathname.startsWith(`${PATIENT_PORTAL_PATH_PREFIX}/`)
  );
}
